

const themeReducer = (state, action) => {
    if (action.type === 'colorA') {
        return { ...state, primary: "colorA" }
    }
    if (action.type === 'colorB') {
        return { ...state, primary: "colorB" }
    }
    if (action.type === 'colorC') {
        return { ...state, primary: "colorC" }
    }
    if (action.type === 'colorX') {
        return { ...state, primary: "colorX" }
    }
    if (action.type === 'colorY') {
        return { ...state, primary: "colorY" }
    }
    if (action.type === 'colorZ') {
        return { ...state, primary: "colorZ" }
    }

    // backgroundColors

    if (action.type === 'bg-1') {
        return { ...state, background: "bg-1" }
    }

    if (action.type === 'bg-2') {
        return { ...state, background: "bg-2" }
    }

}

export default themeReducer

